import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="max-w-2xl mx-auto w-full pt-[200px] min-h-custom-screen justify-center bg-white text-center min-[42rem]:border-x border-[#e2e2e2]">
      <h1 className="text-4xl font-bold">404</h1>
      <p className="text-2xl">صفحه مورد نظر یافت نشد</p>
      <p className="mt-3 mb-4">صفحه ای که در جستجوی آن هستید وجود ندارد. </p>
      <Button className="mt-4" size="sm">
        <Link to="/">
          بازگشت به صفحه اصلی
        </Link>
      </Button>
    </div>
  );
};

export default NotFound;
